import { db } from 'firebase/index'
import { hideLoadingAction, showLoadingAction } from 'reducks/loading/actions'
import { Action, Dispatch } from 'redux'
import {
  StoreDefaultBreadType,
  StoreDefaultDeliveryBreadType,
  StoreDefaultScheduleType,
  StoreDefaultType,
} from 'types/storeDefault'
import { push } from 'connected-react-router'

type Params = {
  nextStoreDefault: StoreDefaultType
  nextStoreDefaultBread: StoreDefaultBreadType
  nextStoreDefaultSchedules: StoreDefaultScheduleType[]
  nextStoreDefaultDeliveryBread: StoreDefaultDeliveryBreadType
  prevStoreDefaultSchedules: StoreDefaultScheduleType[]
  prevStoreDefaultDeliveryBread: StoreDefaultDeliveryBreadType | undefined
}

const saveDefault = (params: Params) => {
  return async (dispatch: Dispatch<Action>) => {
    const batch = db.batch()

    try {
      const {
        nextStoreDefault,
        nextStoreDefaultBread,
        nextStoreDefaultSchedules,
        nextStoreDefaultDeliveryBread,
        prevStoreDefaultSchedules,
        prevStoreDefaultDeliveryBread,
      } = params

      // storeDefaultBread の追加・更新
      const nextStoreDefaultBreadRef = nextStoreDefaultBread.store_default_bread_ref
      batch.set(nextStoreDefaultBreadRef, nextStoreDefaultBread, { merge: true })

      // storeDefault の追加・更新
      const nextStoreDefaultRef = nextStoreDefaultBreadRef.parent.parent
      if (!nextStoreDefaultRef) return
      batch.set(nextStoreDefaultRef, nextStoreDefault, { merge: true })

      // schedules の追加・更新
      for (const nextStoreDefaultSchedule of nextStoreDefaultSchedules) {
        const { schedule_ref, ...rest } = nextStoreDefaultSchedule
        if (!schedule_ref) continue
        console.log(schedule_ref.id)
        batch.set(schedule_ref, rest, { merge: true })
      }
      // 既存の schedules に存在しているが、更新後の schedules に存在しないものを削除する
      for (const prevStoreDefaultSchedule of prevStoreDefaultSchedules) {
        const { schedule_ref } = prevStoreDefaultSchedule
        if (!schedule_ref) continue
        console.log(schedule_ref.id)
        const isExist = nextStoreDefaultSchedules.some(
          (nextStoreDefaultSchedule) => nextStoreDefaultSchedule.schedule_ref?.id === schedule_ref.id
        )
        if (isExist) continue
        batch.delete(schedule_ref)
      }

      // 取り寄せの受付設定にチェックが入っていれば delivery_breads を追加・更新
      if (nextStoreDefaultBread.is_type_delivery) {
        const { ref, ...rest } = nextStoreDefaultDeliveryBread
        const nextStoreDefaultDeliveryBreadRef =
          ref ?? nextStoreDefaultRef.collection('store_default_delivery_breads').doc()
        batch.set(nextStoreDefaultDeliveryBreadRef, rest, { merge: true })
      } else if (!nextStoreDefaultBread.is_type_delivery && prevStoreDefaultDeliveryBread) {
        const { ref } = prevStoreDefaultDeliveryBread
        if (ref) {
          batch.delete(ref)
        }
      }

      dispatch(showLoadingAction())
      await batch.commit()
      dispatch(hideLoadingAction())
      dispatch(push('/product'))
    } catch (error) {
      console.log(error)
      dispatch(hideLoadingAction())
    }
  }
}

export default saveDefault
